import React from "react";
import PropTypes from "prop-types";

import { AvatarPlaceholderImg } from "../shared";
import { UserAvatar, AvatarWrapper } from "./styles";

const LoggedInLinks = ({ userAvatarUrl, active }) => (
    <AvatarWrapper>
        {userAvatarUrl ? (
            <UserAvatar src={userAvatarUrl} active={active} />
        ) : (
            <AvatarPlaceholderImg active={active} />
        )}
    </AvatarWrapper>
);

LoggedInLinks.propTypes = {
    userAvatarUrl: PropTypes.string,
    active: PropTypes.bool,
};

export { LoggedInLinks };
